import { useState } from "react";
import FiltersBar from "./FiltersBar";
import EscalationsTable from "./EscalationsTable";
import DetailModal from "./DetailModal";

/**
 * Assigned-Escalations tab — orchestrates filters, table, and detail modal.
 *
 * Props:
 *   assignedEscalations {array}
 *   groups              {array}
 *   selectedGroup       {string}
 *   setSelectedGroup    {function}
 *   loading             {boolean}
 *   onUpdateStatus      {function}  — (escalationId, newStatus) => void
 *   theme               {string}
 *   screenSize          {string}
 *   language            {"en"|"ar"}
 *   t                   {object}
 *   styles              {object}
 *   fonts               {object}
 *   spacing             {object}
 *   StatusBadge         {component}
 */
const GroupAssignedEscalation = ({
  assignedEscalations,
  groups,
  selectedGroup,
  setSelectedGroup,
  loading,
  onUpdateStatus,
  theme,
  screenSize,
  language,
  t,
  styles,
  fonts,
  spacing,
  StatusBadge,
}) => {
  const [selectedType, setSelectedType] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectedEscalation, setSelectedEscalation] = useState(null);

  const getFiltered = () => {
    let filtered = [...assignedEscalations];

    if (selectedType !== "all") {
      filtered = filtered.filter(
        (e) => e.type?.toLowerCase() === selectedType.toLowerCase()
      );
    }
    if (selectedStatus !== "all") {
      filtered = filtered.filter((e) => e.status === selectedStatus);
    }

    filtered.sort((a, b) => {
      const da = new Date(a.issuedAt);
      const db = new Date(b.issuedAt);
      return sortOrder === "desc" ? db - da : da - db;
    });

    return filtered;
  };

  const handleUpdateStatus = async (escalationId, newStatus) => {
    await onUpdateStatus(escalationId, newStatus);
    setSelectedEscalation(null);
  };

  return (
    <>
      <div
        style={{
          ...styles.statCard,
          marginTop: "1rem",
          marginBottom: "2rem",
        }}
      >
        <FiltersBar
          groups={groups}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
          theme={theme}
          screenSize={screenSize}
          fonts={fonts}
          styles={styles}
          language={language}
          t={t}
        />

        <EscalationsTable
          escalations={getFiltered()}
          loading={loading}
          theme={theme}
          screenSize={screenSize}
          fonts={fonts}
          styles={styles}
          language={language}
          t={t}
          StatusBadge={({ status }) => (
            <StatusBadge
              status={status}
              t={t}
              screenSize={screenSize}
              fonts={fonts}
            />
          )}
          onViewDetails={setSelectedEscalation}
        />
      </div>

      {selectedEscalation && (
        <DetailModal
          escalation={selectedEscalation}
          onClose={() => setSelectedEscalation(null)}
          onUpdateStatus={handleUpdateStatus}
          loading={loading}
          theme={theme}
          screenSize={screenSize}
          styles={styles}
          spacing={spacing}
          fonts={fonts}
          language={language}
          t={t}
          StatusBadge={({ status }) => (
            <StatusBadge
              status={status}
              t={t}
              screenSize={screenSize}
              fonts={fonts}
            />
          )}
        />
      )}
    </>
  );
};

export default GroupAssignedEscalation;